// src/constants/localisation/localisation.ts
var LANGUAGE_MAP = {
  en: {
    displayName: "English",
    locale: "en-us",
    code: "en",
    translatedName: "English",
    supported: true
  },
  it: {
    displayName: "Italiano",
    locale: "it-it",
    code: "it",
    translatedName: "Italian",
    supported: true
  },
  es: {
    displayName: "Espa\xF1ol",
    locale: "es-es",
    code: "es",
    translatedName: "Spanish",
    supported: true
  },
  fr: {
    displayName: "Fran\xE7ais",
    locale: "fr-fr",
    code: "fr",
    translatedName: "French",
    supported: true
  },
  de: {
    displayName: "Deutsch",
    locale: "de-de",
    code: "de",
    translatedName: "German",
    supported: true
  },
  nl: {
    displayName: "Nederlands",
    locale: "nl-nl",
    code: "nl",
    translatedName: "Dutch",
    supported: true
  },
  pt: {
    displayName: "Portugu\xEAs",
    locale: "pt-br",
    code: "pt",
    translatedName: "Portuguese",
    supported: true
  },
  id: {
    displayName: "Indonesian",
    locale: "id-id",
    code: "id",
    translatedName: "Indonesian",
    supported: false
  },
  pl: {
    displayName: "Polski",
    locale: "pl-pl",
    code: "pl",
    translatedName: "Polish",
    supported: true
  },
  ar: {
    displayName: "Arabic",
    locale: "ar-ae",
    code: "ar",
    translatedName: "Arabic",
    supported: false
  },
  ru: {
    displayName: "\u0420\u0443\u0441\u0441\u043A\u0438\u0439",
    locale: "ru-ru",
    code: "ru",
    translatedName: "Russian",
    supported: true
  },
  da: {
    displayName: "Dansk",
    locale: "da-dk",
    code: "da",
    translatedName: "Danish",
    supported: true
  },
  no: {
    displayName: "Norsk",
    locale: "no-nb",
    code: "no-nb",
    translatedName: "Norwegian",
    supported: true
  },
  ro: {
    displayName: "Rom\xE2n\u0103",
    locale: "ro-ro",
    code: "ro",
    translatedName: "Romanian",
    supported: true
  },
  sv: {
    displayName: "Svenska",
    locale: "sv-se",
    code: "sv",
    translatedName: "Swedish",
    supported: true
  },
  tr: {
    displayName: "T\xFCrk\xE7e",
    locale: "tr-tr",
    code: "tr",
    translatedName: "Turkish",
    supported: true
  }
};
var SUPPORTED_LANGUAGES = Object.values(LANGUAGE_MAP).reduce(
  (acc, obj) => {
    if (obj.supported) {
      acc.push(obj.code);
    }
    return acc;
  },
  []
);
var UNSUPPORTED_LANGUAGES = Object.values(LANGUAGE_MAP).reduce(
  (acc, obj) => {
    if (!obj.supported) {
      acc.push(obj.code);
    }
    return acc;
  },
  []
);
var DEFAULT_LANGUAGE = "en";
var LANGUAGE_SORT_ORDER = ["en", "es", "fr", "it", "de", "pt", "nl"];

export {
  LANGUAGE_MAP,
  SUPPORTED_LANGUAGES,
  UNSUPPORTED_LANGUAGES,
  DEFAULT_LANGUAGE,
  LANGUAGE_SORT_ORDER
};
